//angular imports
import { signal, WritableSignal } from "@angular/core";
import { ListItem } from "@app/shared";



export abstract class AbstractProjectModel {

  public id: string = "";
  public name: WritableSignal<string> = signal<string>(null);
  public description: WritableSignal<string> = signal<string>(null);
  public isActive: WritableSignal<boolean> = signal<boolean>(false);
  public isChecked: WritableSignal<boolean> = signal<boolean>(false);
  public hasImageError: WritableSignal<boolean> = signal<boolean>(false);


  constructor() {
    this.name = signal<string>(null);
    this.description = signal<string>(null);        
    this.isChecked = signal<boolean>(false);
    this.isActive = signal<boolean>(false);
  }

  public select = (val: boolean): void => {
    this.isChecked.set(val);
  };

  public abstract toListItem(selected?: boolean): ListItem<any>;
  public abstract toListItem$(selected: WritableSignal<boolean>): ListItem<any>;

  public handleImageError(): void {
    this.hasImageError.set(true);
  }

}